"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKnockDisplayName = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper/broadcastSourceHelper");
var initialDisplayState = {
  displayName: null,
  sourceId: null,
  loaded: false
};

/**
 * Hook to handle the display name of a given knock
 */
var useKnockDisplayName = exports.useKnockDisplayName = function useKnockDisplayName(_ref) {
  var sources = _ref.sources,
    name = _ref.name,
    onAssignKnockToSource = _ref.onAssignKnockToSource;
  var _useState = (0, _react.useState)(initialDisplayState),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    displayState = _useState2[0],
    setDisplayState = _useState2[1];
  var handleAssignKnock = (0, _react.useCallback)(function (sourceId) {
    return onAssignKnockToSource(sourceId);
  }, [onAssignKnockToSource]);
  (0, _react.useEffect)(function () {
    if (!displayState.loaded) {
      var defaultSource = (0, _broadcastSourceHelper.getDefaultCameraSource)(sources, name);
      setDisplayState({
        displayName: defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource.title,
        sourceId: defaultSource === null || defaultSource === void 0 ? void 0 : defaultSource._id,
        loaded: true
      });
    }
  }, [name, sources, displayState]);
  (0, _react.useEffect)(function () {
    if (displayState) {
      handleAssignKnock(displayState === null || displayState === void 0 ? void 0 : displayState.sourceId);
    }
  }, [displayState, handleAssignKnock]);
  var updateDisplayState = function updateDisplayState(state) {
    setDisplayState(state);
    handleAssignKnock(state.sourceId);
  };
  var displayName = displayState.displayName,
    sourceId = displayState.sourceId;
  return {
    displayName: displayName,
    sourceId: sourceId,
    updateDisplayState: updateDisplayState
  };
};